$(document).ready(function() {
	// base url
	if (location.hostname == 'dev.spleen-creation.be' || location.hostname == 'localhost') {
		var path = '/cefim/';
	} else {
		var path = '/';
	}

	var token = $('html').attr('token');

    // init tinyMCE

    var section = "";
    var id_record = 0;

    var hash = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    var target = hash[0].split('=');
    var section = target[1].substring(0, 4);

    $.each(hash, function(index, item) {
    	var param = item.split('=');
    	if (param[0].substring(0, 3) == 'Id_') {
    		id_record = param[1];
    		return false;
    	}
    	if (param[0] == 'target' && param[1] == 'flash') {
    		id_record = 1;
    		return false;
    	}
    });

    tinymce.init({
    	selector: '.tinymce',
    	plugins: "autoresize link image media lists advlist code help paste table",
    	paste_as_text: true,
    	autoresize_bottom_margin: 20,
    	branding: false,
    	menubar:false,
    	statusbar: false,
    	entity_encoding: "raw",
    	toolbar: "undo redo | formatselect | bold italic underline forecolor fontsizeselect | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat | link media image | code | help",
    	image_title: true,
    	automatic_uploads: true,
    	file_picker_types: 'image',
    	file_picker_callback: function (cb, value, meta) {
    		var input = document.createElement('input');
    		input.setAttribute('type', 'file');
    		input.setAttribute('accept', 'image/*');
    		input.setAttribute('name', 'img_cont');

    		input.onchange = function () {
    			var file = this.files[0];

    			var reader = new FileReader();
    			reader.onload = function () {

    				var id = 'blobid' + (new Date()).getTime();
    				var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
    				var base64 = reader.result.split(',')[1];
    				var blobInfo = blobCache.create(id, file, base64);
    				blobCache.add(blobInfo);

    				var file_input = $(input).prop('files')[0];
    				var formData = new FormData();
    				formData.append('file', file_input);
    				formData.append('section', section);
    				formData.append('id_record', id_record);

    				$.ajax({
    					url: 'filebrowser.php',
    					dataType: 'json',  
    					cache: false,
    					contentType: false,
    					processData: false,
    					data: formData,                         
    					type: 'post',
    					success: function(response){
    						if (response.action == "bad_ext"){

    							toastr.error("Invalid extension file (accept .jpg, .jpeg, .png, .gif)");

    						}
    						else if (response.action == "success") {

    							cb(response.img_path, { 
    								alt: file.name,
    								title: file.name
    							});

    						}
    					}
    				});

    			};
    			reader.readAsDataURL(file);
    		};
    		input.click();
    	}
    });

    	$(".datetimepicker").flatpickr(
    		{
	    		enableTime: true,
	    		dateFormat: "d-m-Y H:i",
	    		time_24hr: true,
	    		minuteIncrement: 15,
	    		'locale' : {
		        "firstDayOfWeek": 1 // start week on Monday
		    	},
	    		locale: 'fr',
	    	}
    	);

	// init toastr
	toastr.options = {
		"closeButton": true,
		"debug": false,
		"newestOnTop": false,
		"progressBar": false,
		"positionClass": "toast-top-center",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": "2000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	// init datepicker
	$('.datepicker').datepicker({
	    format: "dd-mm-yyyy",
	    weekStart: 1,
	    daysOfWeekDisabled: "0,6",
    		startDate: '0d'
	});

	// init selectpicker
	$('.selectpicker').selectpicker({
		iconBase: 'fas',
		size: 8
	});
	$(document).on('click', '.bootstrap-select button', function(e) {
		e.preventDefault();
		return false;
	});

	// init datatable
	if($('body').find('.data-table').length>0) {
		//var language = $('html').attr('lang');
		$('.data-table').DataTable({
			responsive: true,
			fixedHeader: {
				header: false,
				footer: true
			},
	           /* "language": {
	                "url": "assets/plugins/dataTables/datatable/datatable."+ language +".json"
	           },*/
	           "pageLength": 25,
	           "aaSorting": []
	     });

		$.fn.dataTable.moment = function ( format, locale ) {
			var types = $.fn.dataTable.ext.type;

		    // Add type detection
		    types.detect.unshift( function ( d ) {
		    	return moment( d, format, locale, true ).isValid() ?
		    	'moment-'+format :
		    	null;
		    } );

		    // Add sorting method - use an integer for the sorting
		    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
		    	return moment( d, format, locale, true ).unix();
		    };
		};

		$.fn.dataTable.moment( 'DD-MM-YYYY' );
	}

	// init datatable export
	if($('body').find('.data-table-export').length>0) {
		//var language = $('html').attr('lang');
		var table_export = $('.data-table-export').DataTable({
			responsive: true,
			fixedHeader: {
				header: false,
				footer: true,
				footerOffset: $('#fixed').height()	
			},
			dom: 'lBfrtip',
			buttons: [
				{ 
					extend: 'copy', 
					className: 'btn btn-outline-primary btn-sm px-3',
				    init: function(api, node, config) {
				       $(node).removeClass('dt-button')
				    } 
				},
				{ 
					extend: 'csv', 
					className: 'btn btn-outline-primary btn-sm px-3',
				    init: function(api, node, config) {
				       $(node).removeClass('dt-button')
				    } 
				},
				{ 
					extend: 'excel', 
					className: 'btn btn-outline-primary btn-sm px-3',
				    init: function(api, node, config) {
				       $(node).removeClass('dt-button')
				    } 
				},
				{ 
					extend: 'pdf', 
					className: 'btn btn-outline-primary btn-sm px-3',
				    init: function(api, node, config) {
				       $(node).removeClass('dt-button')
				    } 
				},
				{ 
					extend: 'print', 
					className: 'btn btn-outline-primary btn-sm px-3',
				    init: function(api, node, config) {
				       $(node).removeClass('dt-button')
				    } 
				}
			],
	           /* "language": {
	                "url": "assets/plugins/dataTables/datatable/datatable."+ language +".json"
	           },*/
	           "pageLength": 100,
	           "aaSorting": []
	     });

		$.fn.dataTable.moment = function ( format, locale ) {
			var types = $.fn.dataTable.ext.type;

		    // Add type detection
		    types.detect.unshift( function ( d ) {
		    	return moment( d, format, locale, true ).isValid() ?
		    	'moment-'+format :
		    	null;
		    } );

		    // Add sorting method - use an integer for the sorting
		    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
		    	return moment( d, format, locale, true ).unix();
		    };
		};

		$.fn.dataTable.moment( 'DD-MM-YYYY' );

		if($('body').find('[data-filter]').length>0) {
			table_export.search($('[data-filter]').data('filter')).draw();
		}
	}

	if($('body').find('.data-table-order').length>0) {
		var table = $('.data-table-order').DataTable({
			rowReorder: true,
			"pageLength": 25
		});

		table.on( 'row-reorder', function ( e, diff, edit ) {

			var order_arr = new Array;	

			$('.data-table-order tbody tr').each(function() {
				order_arr.push($(this).data('id'));
			});

			if ($(this).hasClass('partners_table')) {
				$.getJSON(path+'administration/request/xhr/partners/order.php', {order_arr: order_arr}, function(response) {
					console.log(order_arr);
				});
			}
			else {
				$.getJSON(path+'administration/request/xhr/prod/order.php', {order_arr: order_arr}, function(response) {
					console.log(order_arr);
				});
			}
		} );
	}	

	$(document).on('change', '.decimal-format', function(e) {
		$(this).val($(this).val().replace(',', '.'));
	});

	// personnalise les datas à transmettre en dehors d'un serializeArray() dans la fonction xhr_send()
	function xhr_data(file = null, data) {
		switch(file) {
			/*case 'folder/file' (data-xhr):
				
		    	break;*/
		    default:
		    	return true;
	    }
	}

	// personnalise les callback en cas de succès dans la fonction xhr_send()
	function xhr_success(callback = null, response) {
		switch(callback) {

			/*case 'folder/file' (data-xhr):
				
		    	break;*/
			default:
				return true;
		}

	}

	// fonction principale pour l'envoie et le controle de requêtes ajax
	function xhr_send(path, token, $this) {
		var file = $this.data('xhr');
		if($this.data('type') !== undefined) {
			var type = $this.data('type');
		}
		else {
			var type = null;
		}
		var form = '#'+$this.closest('form').attr('id');

		if(type == 'delete') {
			var id = $this.closest('[data-id]').data('id');

			if(confirm('Voulez-vous supprimer cette ligne ?')) {
				$.post(path+'administration/request/xhr/'+file+'.php', { id: id, token: token }, function(response, statusText, jqXHR) {
					if(response.action == 'success') {

						if(response.callback === true) {
							xhr_success(file, response);
						}
						else {
							if(response.msg != null) {
								toastr.success(response.msg);
							}
							$this.closest('[data-id]').remove()					
						}

						if(response.url != null) {
							location.href = response.url;
						}
					}
					else if(response.action == 'empty') {
						if(response.msg != null) {
							toastr.warning(response.msg);
						}
					}
					else if(response.action == 'token') {
						location.reload();
					}   
					else {
						if(response.msg != null) {
							toastr.error(response.msg);
						}
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
					}
				}, 'json')
				.always(function(jqXHR) {
				    if(jqXHR.status == 404) {
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
				    }
				    else if(jqXHR.status == 500) {			    	
						toastr.error('Request error. Please contact the support');

						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', token: token}, function(response2) {}, 'json');
				    }
				});
			}
		}
		else {
			var data = $(form).serializeArray();
			data[data.length] = { name: 'token', value: token };

			$('.tinymce').each(function() {
				var currentEditorId = $(this).attr('id');
				var val = tinyMCE.get($(this).attr('id')).getContent();

				for (index = 0; index < data.length; ++index) {
				    if (data[index].name == currentEditorId) {
				        data[index].value = val;
				    }
				}
			});

			xhr_data(file, data);

			$('.input__field--error').removeClass('input__field--error');
			$.post(path+'administration/request/xhr/'+file+'.php', data, function(response, statusText, jqXHR) {
				if(response.action == 'success') {
					if(response.callback === true) {
						xhr_success(file, response);
					}
					else {
						if(response.msg != null) {
							toastr.success(response.msg);						
						}
					}

					if(response.url != null) {
						location.href = response.url;
					}
				}
				else if(response.action == 'empty') {
					if(response.msg != null) {
						toastr.warning(response.msg);
					}

					$.each(response.fields, function(i, item) {
					    $(form).find('#'+item).addClass('input__field--error');
					});
				}
				else if(response.action == 'token') {
					location.reload();
				}
				else {
					if(response.msg != null) {
						toastr.error(response.msg);
					}

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', debug:true, token: token}, function(response2) {}, 'json');
				}
			}, 'json')
			.always(function(jqXHR) {
			    if(jqXHR.status == 404) {
					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
			    }
			    else if(jqXHR.status == 500) {			    	
					toastr.error('Request error. Please contact the support');

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', token: token}, function(response2) {}, 'json');
			    }
			});
		}
	}

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('click', '[data-xhr]', function(e) {
		e.preventDefault();
		var $this = $(this);

		xhr_send(path, token, $this);
	});

	function table_order(path, folder) {
		if($('body').find('.data-table-'+folder+'-order').length>0) {
	        var table = $('.data-table-'+folder+'-order').DataTable({
	            rowReorder: true,
	            "pageLength": 25
	        });

	        table.on( 'row-reorder', function ( e, diff, edit ) {

		        var order_arr = new Array;	

		        $('.data-table-'+folder+'-order tbody tr').each(function() {
		        	order_arr.push($(this).data('id'));
		        });

		        $.post(path+'administration/request/xhr/'+folder+'/order.php', {order_arr: order_arr, token: token}, function(response) {
		        }, 'json');
		    } );
		}
	}

	$(document).on('keyup', '.count-char', function() {
		var count = $(this).val().length;
		console.log(count);
		var max = $(this).data('max-char');

		if(count > max) {
			count = '<span class="text-danger">'+count+'</span>';
		}

		$(this).closest('div').find('.count-char-result').html(count);
	});

	$('.delete').click(function(e){
		if (confirm('Voulez-vous vraiment supprimer ceci?')) {
			$(this).next('form').submit();
		}
		e.preventDefault();
	});

    // ajout et construction d'une section
    $(document).on('click', '.line', function() {
    	var id = $(this).attr('id').split('_')[1];
    	$.get(path+'administration/template/section/_builder.php', {id: id}, function(response) {
    		$('#section_target').append(response.replace('[rel]', ''));
    		$('#section-modal').modal('toggle');
    		$("html, body").animate({ scrollTop: $(document).height() }, 1000);
    	});    		
    });

    // ajout et construction d'une section
    $(document).on('click', '#section_target section', function() {
    	$('#section_target section').removeClass('active');
    	$(this).addClass('active');
    	$('.section-option').slideDown('fast');

    	// ajuster le checkbox fluid
    	if($(this).find('.control').hasClass('class_fluid')) {
    		$('.section-option').find('#fluid').prop('checked', true);
    	}
    	else {
    		$('.section-option').find('#fluid').prop('checked', false);
    	}

    	$('.section-option').find('#id_class').val($(this).find('.control').attr('rel'));
    });

    $(document).on('click', '.close-section', function () {
    	$('#section_target section').removeClass('active');
    	$(".section-option").slideUp('fast');
    });

    $(document).on('click', '#fluid', function () {
    	if($(this).is(':checked')) {
    		$('section.active .control').addClass('class_fluid');
    	}
    	else {			
    		$('section.active .control').removeClass('class_fluid');
    	}
    });

    $(document).on('change', '#id_class', function () {
    	var val = $(this).val();
    	$('section.active .control').attr('rel', val);
    });

    $(document).on('click', '#editor button', function(e) {  
    	var $this= $(this);  	
    	var type = $(this).data('type');

    	$.get(path+'administration/template/section/control/'+type+'.php', function(response) {
    		$this.closest('#editor').parent().html(response.replace('[content]', ''));
    		if(type == 'text') {
    			tinymce.init({
    				selector: '.tinymce',
    				plugins: "autoresize link lists advlist code",
    				autoresize_bottom_margin: 20,
    				branding: false,
    				menubar:false,
    				statusbar: false,
    				toolbar: "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | link code"
    			});
    		}
    	});

    	e.preventDefault();
    });

    $(document).on('submit', '#form_image', function(e) {
    	$this = $(this);
    	var formData = new FormData(this);
    	formData.append("type", "img");

    	$.ajax({
    		url: path+"administration/request/content/upload.php",
    		type: "POST",
    		data:  formData, 
    		dataType: 'json',
    		contentType: false,
    		cache: false,
    		processData:false,
    		beforeSend : function()
    		{
				//$("#preview").fadeOut();
				$("#err").fadeOut();
			},
			success: function(response)
			{				

				var filename = response.filename;
				var ext = response.ext;
				var id = response.id;
				$.get(path+'administration/template/section/template/img.php', function(data) {
					$this.find('.preview').html(data.replace('[src]', '../dist/assets/img/upload/cont/'+ filename+'_m.'+ext).replace('[id]', id));

					//'<img src="../files/'+ response.filename+'_m.'+response.ext+'" class="img-fluid" /><input name="img" type="hidden" value="'+response.id+'" />');
				});

				//$this.closest('[data-type]').find('.preview').html('<img src="../files/'+ response.filename+'_m.'+response.ext+'" class="img-fluid" /><input name="img" type="hidden" value="'+response.id+'" />');
			},
			error: function(e) 
			{
				toastr.error(response.msg);
			}          
		});


    	e.preventDefault();
    	return false;
    });

    // ajout d'une image dans le hook depuis la librairie media
    $(document).on('click', '.choose-pic', function(e) {
    	var id = $(this).data('pic');
    	var src = $(this).attr('rel');

    	$(this).closest('[data-type]').find('input[name="img"]').val(id);
    	$(this).closest('[data-type]').find('.preview img').attr('src', src);

    	$('#choose-pic-modal').modal('toggle');
    });

    $('.custom-file-input').on('change', function() {
    	let fileName = $(this).val().split('\\').pop();
    	$(this).siblings('.custom-file-label').addClass('selected').html(fileName);
    });

    $(document).on('submit', '#form_file', function(e) {
    	$this = $(this);

    	$.ajax({
    		url: path+"administration/request/content/upload.php",
    		type: "POST",
    		data:  new FormData(this), 
    		dataType: 'json',
    		contentType: false,
    		cache: false,
    		processData:false,
    		beforeSend : function()
    		{
			//$("#preview").fadeOut();
			$("#err").fadeOut();
		},
		success: function(response)
		{	
			location.reload();
		},
		error: function(e) 
		{
			toastr.error(response.msg);
		}          
	});


    	e.preventDefault();
    	return false;
    });

	// save template et contenu
	$(document).on('click', '#update-content', function(e) {
		var page = $('input[name=page]').val();	
		var lang = $('input[name=lang]').val();
		var menu_title = $('input[name=menu_title]').val();
		var admin_title = $('input[name=admin_title]').val();
		var banner_title = $('input[name=banner_title]').val();
		var banner_link = $('select[name=banner_link]').val();

		if($("#Online_page").is(':checked')) {
			var show = 1;
		}
		else {
			var show = 0;
		}

		if($("#secure_login").is(':checked')) {
			var secure_login = 1;
		}
		else {
			var secure_login = 0;
		}	

		if($("#secure").is(':checked')) {
			var secure = 1;
		}
		else {
			var secure = 0;
		}	

		if($("#Menu_visible").is(':checked')) {
			var menu = 1;
		}
		else {
			var menu = 0;
		}

		var menu_id = $('#Menu_id').val();	

		var structure = [];
		var content = [];
		var type = [];
		var val = [];
		var hook = [];
		var fluid = [];
		var add_class = [];
		var i = 0;
		
		$('#section_target section').each(function() {
			structure[i] = $(this).attr('id').split('_')[1];

			// gestion class fluid
			if($(this).find('.control').hasClass('class_fluid')) {
				fluid[i] = 1;
			}
			else {
				fluid[i] = 0;
			}

			// ajout de class/id
			if($(this).find('.control').attr('rel') !== undefined) {
				add_class[i] = $(this).find('.control').attr('rel');
			}
			else {
				add_class[i] = 'null';	 		
			}

			console.log(add_class[i]);

			var type_section = [];
			var val_section = [];
			var j = 0;
			$('div[data-type]', this).each(function() {
				type_section[j] = $(this).data('type');
				type[i] = type_section;

				if($(this).data('type') == 'code') {
					var $this = $(this);
					var hook_section = [];

					$('div[data-hook]', this).each(function(index) {
						if($(this).data('hook') == 'text') {
							var currentEditorId = $(this).find('.tinymce').attr('id');							
							hook_section.push(tinyMCE.get(currentEditorId).getContent());
						}
						else {
							var val = $(this).find('input[name="img"], input[name="video"]').val();
							hook_section.push(val);
							//hook_section.push($(this).val());
						}
					});

					hook[i] = hook_section;
				}

				if($(this).data('type') == 'text') {
					var currentEditorId = $(this).find('.tinymce').attr('id');
					var val = tinyMCE.get(currentEditorId).getContent();
				}
				else {
					var val = $(this).find('input[type="text"], input[type="search"], input[type="hidden"]').val();
					console.log('hidden'+val);
				}
				val_section[j] = val;
				content[i] = val_section;
				j++;
			});

			i++;
		});
		if( $('#Id_page_content').length > 0 ){
			var Id_page_content = $('#Id_page_content').val();
		} else {
			var Id_page_content = "none";
		}
		$.post(path+'administration/request/content/add_section.php', { 
			page: page, 
			lang: lang, 
			menu_title: menu_title,
			admin_title: admin_title,
			banner_title: banner_title,
			banner_link: banner_link,
			show: show, 
			menu: menu, 
			menu_id: menu_id, 
			type: type, 
			structure: structure, 
			content: content, 
			hook: hook,
			fluid: fluid,
			add_class: add_class,
			secure_login: secure_login,
			secure: secure,
			Id_page_content: Id_page_content,
			token: token
		}, function(response) {
			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}			
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
	});

    // save template et contenu
    $(document).on('click', '#save-content', function(e) {
    	var page = $('input[name=page]').val();	
    	var lang = $('input[name=lang]').val();
    	var menu_title = $('input[name=menu_title]').val();
    	var admin_title = $('input[name=admin_title]').val();
	var banner_title = $('input[name=banner_title]').val();
	var banner_link = $('select[name=banner_link]').val();

    	if($("#Online_page").is(':checked')) {
    		var show = 1;
    	}
    	else {
    		var show = 0;
    	}

    	if($("#secure_login").is(':checked')) {
    		var secure_login = 1;
    	}
    	else {
    		var secure_login = 0;
    	}	

    	if($("#secure").is(':checked')) {
    		var secure = 1;
    	}
    	else {
    		var secure = 0;
    	}	

    	if($("#Menu_visible").is(':checked')) {
    		var menu = 1;
    	}
    	else {
    		var menu = 0;
    	}

    	var menu_id = $('#Menu_id').val();	

    	var structure = [];
    	var content = [];
    	var type = [];
    	var val = [];
    	var hook = [];
    	var fluid = [];
    	var add_class = [];
    	var i = 0;

    	$('#section_target section').each(function() {
    		structure[i] = $(this).attr('id').split('_')[1];

	 		// gestion class fluid
	 		if($(this).find('.control').hasClass('class_fluid')) {
	 			fluid[i] = 1;
	 		}
	 		else {
	 			fluid[i] = 0;
	 		}

	 		// ajout de class/id
	 		if($(this).find('.control').attr('rel') !== undefined) {
	 			add_class[i] = $(this).find('.control').attr('rel');
	 		}
	 		else {
	 			add_class[i] = 'null';	 		
	 		}

	 		console.log(add_class[i]);
	 		
	 		var type_section = [];
	 		var val_section = [];
	 		var j = 0;
	 		$('div[data-type]', this).each(function() {
	 			type_section[j] = $(this).data('type');
	 			type[i] = type_section;

	 			if($(this).data('type') == 'code') {
	 				var $this = $(this);
	 				var hook_section = [];

	 				$('div[data-hook]', this).each(function(index) {
	 					if($(this).data('hook') == 'text') {
	 						var currentEditorId = $(this).find('.tinymce').attr('id');							
	 						hook_section.push(tinyMCE.get(currentEditorId).getContent());
	 					}
	 					else {
	 						var val = $(this).find('input[name="img"], input[name="video"]').val();
	 						hook_section.push(val);
	 					}
	 				});

	 				hook[i] = hook_section;
	 			}

	 			if($(this).data('type') == 'text') {
	 				var currentEditorId = $(this).find('.tinymce').attr('id');
	 				var val = tinyMCE.get(currentEditorId).getContent();
	 			}
	 			else {
	 				var val = $(this).find('input[type="text"], input[type="hidden"]').val();
	 				console.log(val);
	 			}
	 			val_section[j] = val;
	 			content[i] = val_section;
	 			j++;
	 		});

	 		i++;
	 	});

    	$.post(path+'administration/request/content/add_section.php', { 
    		page: page, 
    		lang: lang, 
    		menu_title: menu_title,
    		admin_title: admin_title,
		banner_title: banner_title,
		banner_link: banner_link,
    		show: show, 
    		menu: menu, 
    		menu_id: menu_id, 
    		type: type, 
    		structure: structure, 
    		content: content, 
    		hook: hook,
    		fluid: fluid,
    		add_class: add_class,
    		secure_login: secure_login,
    		secure: secure,
    		token: token
    	}, function(response) {
    		if(response.action=='success') {
    			toastr.success(response.msg);
    		}
    		else {
    			toastr.error(response.msg);
    		}
    	}, 'json');

    	e.preventDefault();
    });

	// save template et contenu
	$(document).on('click', '.delete-section', function(e) {
		$(this).closest('section').remove();
		e.preventDefault();
	});


	// ajouter une nouvelle page
	$(document).on('click', '#add-content', function(e) {
		var lang = $('html').attr('lang');
		var data = $('#add-content-form').serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/content/add_content.php', data, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
				document.location.href =  path+'administration/index.php?target=content&lang='+lang+'&process=update&Id_contents='+response.id;
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}            
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	$('select[name=reload_version]').change(function() {
		var Id_page_content = $(this).val();
		var lang = $('input[name=Lng]').val();
		$('#previewBackup').html('<a href="/'+lang+'?Id_page_content='+Id_page_content+'&preview" target="_blank" class="float-right"><i class="fas fa-desktop url_content"></i></a>');
		$('#Id_page_content').val(Id_page_content);
		$.post(path+'administration/request/content/reload.php', { 'Id_page_content' : $(this).val(), 'Lng' : $('input[name=Lng]').val() }, function(response) {
			$('#section_target').html(response);
			tinymce.init({
				selector: '.tinymce',
				plugins: "autoresize link lists advlist code help",
				autoresize_bottom_margin: 20,
				branding: false,
				menubar:false,
				statusbar: false,
				toolbar: "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | link code",
				color_map: [
				"555D65", "Black",
				"E2001A", "Red",
				"89D221", "Green",
				"00254D", "Blue",
				"9ABCE1", "LightBlue"
				]
			});
		});
	});

	$(document).on('change', 'input[name=video]', function(e) {
		var $this = $(this);
		var val = $(this).val();
		$.get(path+'administration/template/section/template/video.php', function(response) {
			$this.closest('[data-type]').find('.preview').html(response.replace('[src]', val));
		});
	});

	$(document).on('change', 'input[name=code]', function(e) {
		var $this = $(this);
		var hook = $(this).val();
		$.get(path+'administration/template/section/template/code.php', {hook: hook}, function(response) {
			$this.closest('[data-type]').find('.preview').html(response);

			tinymce.init({
				selector: '.tinymce',
				plugins: "autoresize link lists advlist code",
				autoresize_bottom_margin: 20,
				branding: false,
				menubar:false,
				statusbar: false,
				toolbar: "formatselect | undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat code help"
			});
		});
	});

	// sortable catégories
	if($('body').find('#section_target section').length>0) {
		$('#section_target').sortable({
			axis: 'y',
			start: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceRemoveEditor', false, $(this).attr('id'));
				});
			},
			stop: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceAddEditor', true, $(this).attr('id'));
				});
			}
		});
	}

	// sortable catégories
	if($('body').find('.preview [data-hook]').length>0) {
		$('.preview').sortable({
			axis: 'y',
			start: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceRemoveEditor', false, $(this).attr('id'));
				});
			},
			stop: function (e, ui) {
				$(ui.item).find('textarea').each(function () {
					tinymce.execCommand('mceAddEditor', true, $(this).attr('id'));
				});
			}
		});
	}


	// mettre une page en ligne ou hors ligne
	$(document).on('click', '#sync-page', function(e) {
		var id = $(this).data('id');
		var lang = $(this).data('lang');
		$.getJSON(path+'administration/request/content/sync-page.php', {id: id, lang: lang, token: token }, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
				location.reload();
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	

	$(document).on('click', '.add-keyword', function(e) {
		$('#form-save-keyword input[type="text"]').val('');
		$('#modal-keyword').modal('show'); 
		e.preventDefault();
	});

	$(document).on('click', '.update-keyword', function(e) {
		var id = $(this).data('id');

		$.getJSON(path+'administration/request/keyword/get-keyword.php', {id:id, token: token }, function(response) {
			if(response.action == 'success') {
				$('#form-save-keyword input[type="text"]').val('');
				$('#form-save-keyword #id_keyword').val(id);

				$.each(response.keywords, function(key, value) {
					$('#form-save-keyword input[name="' + key + '"').val(value);
				});

				$('#modal-keyword').modal('show'); 
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}
			else {
				toastr.error(response.msg);
			}
		});
		e.preventDefault();
	});

	// ajout des données de facturation
	$(document).on('click', '#save-keyword', function(e) {	
		var data = $('#form-save-keyword').serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/keyword/update-keyword.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				$('#modal-keyword').toggle();
				location.reload();
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}			
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('submit', '#update-meta-form', function(e) {
		var lang = $('html').attr('lang');
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/content/meta.php', data, function(response) {

			if(response.action=='success') {
				toastr.success(response.msg);
			}
			else if(response.action=='empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}    
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
	});

	// update des données du user
	$(document).on('click', '#update-membre', function(e) {
		var data = $('#form-user-data').serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/xhr/membre/update-user-data.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// ajout d'un user
	$(document).on('click', '#add-membre', function(e) {
		var data = $('#form-user-data').serializeArray();
		data[data.length] = { name: 'token', value: token };

		$.getJSON(path+'administration/request/xhr/membre/add-user-data.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('click','.log-show', function(e){
		var id = $(this).data('id');

		$.getJSON(path+'administration/request/xhr/logs/get-logs.php', {id:id}, function(response){
			if (response.action == 'success') {
				$('#modal_log').modal('show');
				$('#modal_log .modal-title').html(response.title);
				$('#modal_log .modal-body').html(response.html);
			}
		});
	});

	$(".fancyframecrop").fancybox({
		iframe : {
			css : {
				width : '100%',
				height : '100%'
			}
		}
	});

	$("[data-fancybox]").fancybox({
		iframe : {
			css : {
				'width' : '100%',
				'min-height' : '600px'
			}
		}
	});

	$(document).on('submit', '#form-add-video', function(e) {
    		$this = $(this);
		var formData = new FormData(this);		
		formData.append('token', token);

		$('.progress-btn span').text($this.data('text'));
		$('.progress-bar').width('0%');
		$('.progress-bar').fadeIn();

		$('#form-add-video-btn').prop('disabled', true);

		$.ajax({

			url: path+"administration/request/xhr/video/add-video.php",
			type: "POST",
			data:  formData, 
    			dataType: 'json',
			contentType: false,
			cache: false,
			processData:false,
			beforeSend : function()
			{
			//$("#preview").fadeOut();
				$("#err").fadeOut();
			},
			success: function(response)
			{				
				if(response.action == 'success') {
					toastr.success(response.msg);
					location.href = 'index.php?target=video';
					
				}
				else if(response.action == 'empty') {
					$('#form-add-video-btn').prop('disabled', true);
					toastr.warning(response.msg);
				}
				else if(response.action == 'token') {
					location.reload();
				}   
				else {
					$('#form-add-video-btn').prop('disabled', true);
					toastr.error(response.msg);
				}
			},
			error: function(response) 
			{
				$('#form-add-video-btn').prop('disabled', true);
				toastr.error(response.msg);
			},
			xhr: function(){
				/*if(uploadInput != undefined){*/
	                    var xhr = new XMLHttpRequest();

	                    xhr.upload.addEventListener('progress', function(e){
	                        if(e.lengthComputable){
							var uploadPercent = e.loaded / e.total;
							uploadPercent = (uploadPercent * 100);

							$('.progress-btn span').text(Math.round(uploadPercent) + '%');
							$('.progress-bar').width(uploadPercent + '%');

							if(uploadPercent == 100){
								console.log($this.find('button.progress-btn'));
								$('.progress-bar').fadeOut();
								$('.progress-btn span').text($this.find('button.progress-btn').data('text')+'ed');
							}
	                    	}
	                    }, false);

	                    return xhr;
	               /*}*/
               }        
		});


		e.preventDefault();
		return false;
	});

	$(document).on('submit', '#form-update-video', function(e) {
    		$this = $(this);
		var formData = new FormData(this);		
		formData.append('token', token);

		$('.progress-btn span').text($this.data('text'));
		$('.progress-bar').width('0%');
		$('.progress-bar').fadeIn();

		$.ajax({

			url: path+"administration/request/xhr/video/update-video.php",
			type: "POST",
			data:  formData, 
    			dataType: 'json',
			contentType: false,
			cache: false,
			processData:false,
			beforeSend : function()
			{
			//$("#preview").fadeOut();
				$("#err").fadeOut();
			},
			success: function(response)
			{				
				if(response.action == 'success') {
					toastr.success(response.msg);

					if(response.video != null) {
						$('#video-preview').find('source').attr('src', '/dist/assets/video/presentation/'+response.video);
						$('#video-preview')[0].load();
					}

					if(response.thumb != null) {
						$('#thumb-preview').attr('src', '/dist/assets/img/upload/presentation/'+response.thumb);
						$('#thumb-preview')[0].load();
					}
					
				}
				else if(response.action == 'empty') {
					toastr.warning(response.msg);
				}
				else if(response.action == 'token') {
					location.reload();
				}   
				else {
					toastr.error(response.msg);
				}
			},
			error: function(response) 
			{
				toastr.error(response.msg);
			},
			xhr: function(){
                    var xhr = new XMLHttpRequest();

                    xhr.upload.addEventListener('progress', function(e){
                        if(e.lengthComputable){
						var uploadPercent = e.loaded / e.total;
						uploadPercent = (uploadPercent * 100);

						$('.progress-btn span').text(Math.round(uploadPercent) + '%');
						$('.progress-bar').width(uploadPercent + '%');

						if(uploadPercent == 100){
							console.log($this.find('button.progress-btn'));
							$('.progress-bar').fadeOut();
							$('.progress-btn span').text($this.find('button.progress-btn').data('text')+'d');
						}
                    	}
                    }, false);

                    return xhr;
               }        
		});


		e.preventDefault();
		return false;
	});

	$(document).on('click', '.preview-video', function (e) {
		e.preventDefault();
		var href = $(this).attr('href');
		$('#modal-preview-video').find('source').attr('src', href+ '?autoplay=1&amp;modestbranding=1&amp;showinfo=0');
		$('#video-preview')[0].load();
		$('#modal-preview-video').modal('show');
		$('#video-preview')[0].play();
		$('#video-preview').prop('muted', true);
	});
	$('#modal-preview-video').on('hidden.bs.modal', function () {
		$('#video-preview')[0].pause();
	});

	// ajout d'un témoignage
	$(document).on('submit', '#form-add-temoignage', function(e) {
		var $this = $(this);
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'administration/request/xhr/testimonial/add-testimonial.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);

				$.each(response.fields, function(i, item) {
				    $this.find('#'+item).addClass('input__field--error');
				});
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
		return false;
	});

	// modification d'un témoignage
	$(document).on('submit', '#form-update-temoignage', function(e) {
		var $this = $(this);
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'administration/request/xhr/testimonial/update-testimonial.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);

				$.each(response.fields, function(i, item) {
				    $this.find('#'+item).addClass('input__field--error');
				});
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
		return false;
	});

	// suppression d'un témoignage
	$(document).on('click', '.delete-testimonial', function(e) {
		var $this = $(this);
		var id = $(this).closest('[data-id]').data('id');

		if(confirm('Voulez-vous supprimer ce témoignage ?')) {
			$.post(path+'administration/request/xhr/testimonial/delete-testimonial.php', { id: id, token: token }, function(response) {
				if(response.action == 'success') {
					toastr.success(response.msg);
					$this.closest('[data-id]').remove()
				}
				else if(response.action == 'empty') {
					toastr.warning(response.msg);
				}
				else if(response.action == 'token') {
					location.reload();
				}   
				else {
					toastr.error(response.msg);
				}
			}, 'json');
		}

		e.preventDefault();
		return false;
	});

	table_order(path, 'testimonial')

	// ajout d'un job
	$(document).on('submit', '#form-add-job', function(e) {
		var $this = $(this);
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'administration/request/xhr/job/add-job.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);

				$.each(response.fields, function(i, item) {
				    $this.find('#'+item).addClass('input__field--error');
				});
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
		return false;
	});

	// modification d'un job
	$(document).on('submit', '#form-update-job', function(e) {
		var $this = $(this);
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'administration/request/xhr/job/update-job.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);

				$.each(response.fields, function(i, item) {
				    $this.find('#'+item).addClass('input__field--error');
				});
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
		return false;
	});

	// suppression d'un job
	$(document).on('click', '.delete-job', function(e) {
		var $this = $(this);
		var id = $(this).closest('[data-id]').data('id');

		if(confirm('Voulez-vous supprimer cette annonce ?')) {
			$.post(path+'administration/request/xhr/job/delete-job.php', { id: id, token: token }, function(response) {
				if(response.action == 'success') {
					toastr.success(response.msg);
					$this.closest('[data-id]').remove()
				}
				else if(response.action == 'empty') {
					toastr.warning(response.msg);
				}
				else if(response.action == 'token') {
					location.reload();
				}   
				else {
					toastr.error(response.msg);
				}
			}, 'json');
		}

		e.preventDefault();
		return false;
	});

	table_order(path, 'job');

	// ajout d'une formation
	$(document).on('submit', '#form-add-formation', function(e) {
		var $this = $(this);
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'administration/request/xhr/formation/add-formation.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);

				$.each(response.fields, function(i, item) {
				    $this.find('#'+item).addClass('input__field--error');
				});
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
		return false;
	});

	// modification d'une formation
	$(document).on('submit', '#form-update-formation', function(e) {
		var $this = $(this);
		var data = $(this).serializeArray();
		data[data.length] = { name: 'token', value: token };

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'administration/request/xhr/formation/update-formation.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);

				$.each(response.fields, function(i, item) {
				    $this.find('#'+item).addClass('input__field--error');
				});
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		}, 'json');

		e.preventDefault();
		return false;
	});

	// suppression d'une formation
	$(document).on('click', '.delete-formation', function(e) {
		var $this = $(this);
		var id = $(this).closest('[data-id]').data('id');

		if(confirm('Voulez-vous supprimer cette formation ?')) {
			$.post(path+'administration/request/xhr/formation/delete-formation.php', { id: id, token: token }, function(response) {
				if(response.action == 'success') {
					toastr.success(response.msg);
					$this.closest('[data-id]').remove()
				}
				else if(response.action == 'empty') {
					toastr.warning(response.msg);
				}
				else if(response.action == 'token') {
					location.reload();
				}   
				else {
					toastr.error(response.msg);
				}
			}, 'json');
		}

		e.preventDefault();
		return false;
	});

	table_order(path, 'formation');

	$(document).on('change', '#form-session #training', function(e) {
		e.preventDefault();

		var id = $(this).val();

		$.getJSON(path+'administration/request/xhr/session/get-former.php', { id: id, token: token }, function(response) {
			if(response.action == 'success') {
				$('#form-session #former').html(response.output);

				$('.selectpicker').selectpicker('refresh');
				$('#former').selectpicker('val', $('#former').val());
				$('#video').selectpicker('val', response.video);
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		});
	});

	var session_start_at = flatpickr('#form-session #start-at',		
    		{
	    		enableTime: true,
	    		dateFormat: "d-m-Y H:i",
	    		time_24hr: true,
	    		minuteIncrement: 15,
	    		'locale' : {
		        "firstDayOfWeek": 1 // start week on Monday
		    	},
	    		locale: 'fr',
	    	}
	);

	var session_end_at = flatpickr('#form-session #end-at',		
    		{
	    		enableTime: true,
	    		dateFormat: "d-m-Y H:i",
	    		time_24hr: true,
	    		minuteIncrement: 15,
	    		'locale' : {
		        "firstDayOfWeek": 1 // start week on Monday
		    	},
	    		locale: 'fr',
	    	}
	);

	$(document).on('change', '#form-session #start-at', function(){
		var start_at = $(this).val();
		var end_at = $('#end-at').val();
		var end_format = '9999999999';

		var start_format = start_at.split(' ');
		var start_date = start_format[0].split('-');
		start_date = start_date[1]+"/"+start_date[0]+"/"+start_date[2];
		var start_hour = start_format[1]+':00';
		start_format = new Date(start_date+' '+start_hour).getTime();

		if(end_at != '') {
			end_format = end_at.split(' ');
			var end_date = end_format[0].split('-');
			end_date = end_date[1]+"/"+end_date[0]+"/"+end_date[2];
			var end_hour = end_format[1]+':00';
			end_format = new Date(end_date+' '+end_hour).getTime();
		}

		if($('#end-at').val() == '' || start_format > end_format) {
		 	var new_start_at = moment(start_format).format('YYYY-MM-DD HH:mm');
			var next = moment(new_start_at).add(3, 'hours').format('DD-MM-YYYY HH:mm');
			$('#end-at').val(next);
			session_end_at.setDate(next, true);
		}
	});

	$(document).on('change', '#form-add-subscription #training', function(e) {
		e.preventDefault();

		var id = $(this).val();

		$.getJSON(path+'administration/request/xhr/subscription/get-session.php', { id: id, token: token }, function(response) {
			if(response.action == 'success') {
				$('#form-add-subscription #session').html(response.output);

				$('.selectpicker').selectpicker('refresh');
				$('#session').selectpicker('val', $('#session').val());
				if(response.federia == true) {
					$('#federia').parent().removeClass('d-none');
				}
				else {
					$('#federia').parent().addClass('d-none');
				}
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else if(response.action == 'token') {
				location.reload();
			}   
			else {
				toastr.error(response.msg);
			}
		});
	});

	$(document).on('click', '#form-update-training #free', function() {
		if($(this).is(':checked')) {
			$('input[name^="cost"]').prop('readonly', true);
		}
		else {
			$('input[name^="cost"]').prop('readonly', false);
		}
	})



	$(document).on('change', 'select#present', function(e) {
		e.preventDefault();
		var $this = $(this);
		var data = [];
		var id = $(this).closest('[data-id]').data('id');
		var present = $(this).val();
		data[data.length] = { name: 'token', value: token };
		data[data.length] = { name: 'id', value: id };
		data[data.length] = { name: 'present', value: present };

		$('.input__field--error').removeClass('input__field--error');
		$.post(path+'administration/request/xhr/subscription/update-present.php', data, function(response, statusText, jqXHR) {
			if(response.action == 'success') {			
				if(response.msg != null) {
					toastr.success(response.msg);						
				}

				if(present == 1) {
					$this.closest('[data-id]').find('.col-present').html('oui');
				}
				else {
					$this.closest('[data-id]').find('.col-present').html('non');
				}
				location.reload();

			}
			else if(response.action == 'empty') {
				if(response.msg != null) {
					toastr.warning(response.msg);
				}

				$.each(response.fields, function(i, item) {
				    $(form).find('#'+item).addClass('input__field--error');
				});
			}
			else if(response.action == 'token') {
				location.reload();
			}
			else {
				if(response.msg != null) {
					toastr.error(response.msg);
				}

				$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', debug:true, token: token}, function(response2) {}, 'json');
			}
		}, 'json')
		.always(function(jqXHR) {
		    if(jqXHR.status == 404) {
				$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
		    }
		    else if(jqXHR.status == 500) {			    	
				toastr.error('Request error. Please contact the support');

				$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'admin', token: token}, function(response2) {}, 'json');
		    }
		});
	});


});

;(function(root, factory) {
  if (typeof exports === 'object') {
    module.exports = factory(window, document)
  } else {
    root.SimpleScrollbar = factory(window, document)
  }
})(this, function(w, d) {
  var raf = w.requestAnimationFrame || w.setImmediate || function(c) { return setTimeout(c, 0); };

  function initEl(el) {
    Object.defineProperty(el, 'data-simple-scrollbar', { value: new SimpleScrollbar(el), configurable: true });
  }

  function unbindEl(el) {
    if (!Object.prototype.hasOwnProperty.call(el, 'data-simple-scrollbar')) return;
    el['data-simple-scrollbar'].unBind();
    //Remove the elements property
    delete el['data-simple-scrollbar'];
  }

  // Mouse drag handler
  function dragDealer(el, context) {
    var lastPageY;

    el.addEventListener('mousedown', function(e) {
      lastPageY = e.pageY;
      el.classList.add('ss-grabbed');
      d.body.classList.add('ss-grabbed');

      d.addEventListener('mousemove', drag);
      d.addEventListener('mouseup', stop);

      return false;
    });

    function drag(e) {
      var delta = e.pageY - lastPageY;
      lastPageY = e.pageY;

      raf(function() {
        context.el.scrollTop += delta / context.scrollRatio;
      });
    }

    function stop() {
      el.classList.remove('ss-grabbed');
      d.body.classList.remove('ss-grabbed');
      d.removeEventListener('mousemove', drag);
      d.removeEventListener('mouseup', stop);
    }
  }

  // Constructor
  function ss(el) {
    this.target = el;
    this.content = el.firstElementChild;

    this.direction = w.getComputedStyle(this.target).direction;

    this.bar = '<div class="ss-scroll">';
    //Create a reference to the function binding to remove the event listeners
    this.mB = this.moveBar.bind(this);

    this.wrapper = d.createElement('div');
    this.wrapper.setAttribute('class', 'ss-wrapper');

    this.el = d.createElement('div');
    this.el.setAttribute('class', 'ss-content');

    if (this.direction === 'rtl') {
      this.el.classList.add('rtl');
    }

    this.wrapper.appendChild(this.el);

    while (this.target.firstChild) {
      this.el.appendChild(this.target.firstChild);
    }
    this.target.appendChild(this.wrapper);

    this.target.insertAdjacentHTML('beforeend', this.bar);
    this.bar = this.target.lastChild;

    dragDealer(this.bar, this);
    this.moveBar();

    w.addEventListener('resize', this.mB);
    this.el.addEventListener('scroll', this.mB);
    this.el.addEventListener('mouseenter', this.mB);

    this.target.classList.add('ss-container');

    var css = w.getComputedStyle(el);
  	if (css['height'] === '0px' && css['max-height'] !== '0px') {
    	el.style.height = css['max-height'];
    }

    this.unBind = function() {
      //Remove event listeners
      w.removeEventListener('resize', this.mB);
      this.el.removeEventListener('scroll', this.mB);
      this.el.removeEventListener('mouseenter', this.mB);
      
      this.target.classList.remove('ss-container');

      //Unwrap the initial content and remove remaining wrappers
      this.target.insertBefore(this.content, this.wrapper);
      this.target.removeChild(this.wrapper);

      //Remove the bar including its drag-dealer event listener
      this.target.removeChild(this.bar);
      this.bar = null; //make way for the garbage collector
    }
  }

  ss.prototype = {
    moveBar: function(e) {
      var totalHeight = this.el.scrollHeight,
          ownHeight = this.el.clientHeight,
          _this = this;

      this.scrollRatio = ownHeight / totalHeight;

      var isRtl = _this.direction === 'rtl';
      var right = isRtl ?
        (_this.target.clientWidth - _this.bar.clientWidth + 18) :
        (_this.target.clientWidth - _this.bar.clientWidth) * -1;

      raf(function() {
        // Hide scrollbar if no scrolling is possible
        if(_this.scrollRatio >= 1) {
          _this.bar.classList.add('ss-hidden')
        } else {
          _this.bar.classList.remove('ss-hidden')
          _this.bar.style.cssText = 'height:' + Math.max(_this.scrollRatio * 100, 10) + '%; top:' + (_this.el.scrollTop / totalHeight ) * 100 + '%;right:' + right + 'px;';
        }
      });
    }
  }

  function initAll() {
    var nodes = d.querySelectorAll('*[ss-container]');

    for (var i = 0; i < nodes.length; i++) {
      initEl(nodes[i]);
    }
  }

  function unbindAll() {
    var nodes = d.querySelectorAll('.ss-container');

    for (var i = 0; i < nodes.length; i++) {
      unbindEl(nodes[i]);
    }
  }

  d.addEventListener('DOMContentLoaded', initAll);
  ss.initEl = initEl;
  ss.initAll = initAll;
  ss.unbindEl = unbindEl;
  ss.unbindAll = unbindAll;

  var SimpleScrollbar = ss;
  return SimpleScrollbar;
});

var el = document.querySelector('.scroll');
SimpleScrollbar.initEl(el);

